import { schemas } from 'constants/schemas';
import { normalize } from 'normalizr';
import { payments as apiPayments } from 'services/apiV3/payments/payments';

type CreatePayload = {
  callback: (payment: Promise<any>) => void;
  orderId: string;
  token: string;
  locale: string;
  hideUserManagement: boolean;
  recurring: boolean;
  captchaResponse: string;
  platform: string;
  recipient: string;
};

const payments = {
  create: async ({
    orderId,
    token,
    locale,
    hideUserManagement = false,
    callback,
    recurring,
    captchaResponse,
    platform,
    recipient,
  }: CreatePayload) => {
    const params = {
      orderId,
      token,
      locale,
      hideUserManagement,
      recurring,
      captchaResponse,
      platform,
      recipient,
    };
    const payment = await apiPayments.create(params);

    if (callback) {
      callback(payment);
    }

    return normalize(payment, schemas.payment);
  },
};

export { payments };
